/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Select } from '@atoms';
import { NARROW_COL } from '@constants';
import { useArticleTypes } from '@hooks';

import Form from '../Form';

const ArticleTypeField = (props) => {
  const articleTypes = useArticleTypes();

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select placeholder="- Choose an article type -">
        {articleTypes.map(({ label }, i) => (
          // It's just s static string. Save as is so the main websites frontend can render it
          // This manipulation is needed because API can't filter by type which has a white space
          // So they removes whitespaces and lowercases the type O-o
          <Select.Option key={i} value={label}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default ArticleTypeField;
